export function isObject(value: unknown) {
  return typeof value === 'object' && value !== null;
}
